import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { withRouter } from "react-router";

const HomeCarousel = ({ history }) => {
  return (
    <Carousel
      showThumbs={false}
      showStatus={false}
      autoPlay={true}
      interval={5000}
      showArrows={true}
      infiniteLoop={true}
      dynamicHeight={true}
    >
      <div>
        <img
          className="carouselImg"
          src="https://res.cloudinary.com/coinstorey/image/upload/w_1400,h_353/v1630393510/coinstorey/carousel5_eutn57.png"
          alt="carousel"
        />
      </div>
      <div onClick={() => history.push("/tradathon")}>
        <img
          className="carouselImg"
          src="https://res.cloudinary.com/coinstorey/image/upload/w_1400,h_353/v1630393567/coinstorey/carousel6_nohyzc.png"
          alt="carousel"
        />
      </div>
      <div onClick={() => history.push("/vtrading")}>
        <img
          className="carouselImg"
          src="https://res.cloudinary.com/coinstorey/image/upload/w_1400,h_353/v1630393569/coinstorey/carousel7_z5nyay.png"
          alt="carousel"
        />
      </div>
      <div onClick={() => history.push("/tradathon")}>
        <img
          className="carouselImg"
          src="https://res.cloudinary.com/coinstorey/image/upload/w_1400,h_353/v1630393571/coinstorey/carousel8_esofii.png"
          alt="carousel"
        />
      </div>
    </Carousel>
  );
};

export default withRouter(HomeCarousel);
